import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  // {
  //   path: '/products',
  //   name: 'Products',
  //   component: () => import('@/views/products/Products.vue'),
  //   children: [
  //     {
  //       path: 'country-sim',
  //       name: 'CountrySIM',
  //       component: () => import('@/views/products/CountrySIM.vue')
  //     },
  //     {
  //       path: 'device-sim',
  //       name: 'DeviceSIM',
  //       component: () => import('@/views/products/DeviceSIM.vue')
  //     }
  //   ]
  // },
  // 商店sim卡
  {
    path: '/products/type/:type',
    name: 'Products',
    component: () => import('@/views/products/Products.vue'),
  },
  //按国家
  // {
  //   path: '/products/country',
  //   name: 'CountrySIM',
  //   component: () => import('@/views/products/CountrySIM.vue'),
  // },
  //按设备
  // {
  //   path: '/products/device',
  //   name: 'CountrySIM',
  //   component: () => import('@/views/products/DeviceSIM.vue'),
  // },
  //eSIM 列表页
  {
    path: '/products/esim',
    name: 'ESIM',
    component: () => import('@/views/products/ESIM.vue')
  },
  //eSIM详情页
  {
    path: '/products/detail/esim/:country',
    name: 'EsimProductDetail',
    component: () => import('@/views/products/detail/esimProductDetail.vue')
  },
  {
    path: '/products/detail',
    name: 'ProductDetail',
    component: () => import('@/views/products/detail/esimProductDetail.vue')
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/cart/Cart.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user/User.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/user/Orders.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/user/Profile.vue')
      }
    ]
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/views/support/Support.vue'),
    children: [
      {
        path: 'faq',
        name: 'FAQ',
        component: () => import('@/views/support/FAQ.vue')
      },
      
      {
        path: 'how-to-work',
        name: 'HowToWork',
        component: () => import('@/views/support/HowToWork.vue')
      },
      {
        path: 'track',
        name: 'Track',
        component: () => import('@/views/support/Track.vue')
      }
    ]
  },
  {
    path: '/support/return',
    name: 'Return',
    component: () => import('@/views/support/Return.vue')
  },
  {
    path: '/business',
    name: 'Business',
    component: () => import('@/views/business/Business.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters.isAuthenticated

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router 